export const globalEnvironment = {
    APP_VERSION: 30,
    CHANNEL_NAME: 'DESK'
}
